import * as React from 'react';
import { AnalyticsData } from '../types';

type Props = {
  data: AnalyticsData;
};

const AnalyticsStatWidget: React.FC<React.PropsWithChildren<Props>> = ({
  data,
}) => {
  const maxValue = data.chart ? Math.max(...data.chart.values, 1) : 0;

  return (
    <div className="ai-chat-widget ai-chat-widget-analytics">
      <div className="ai-chat-widget-analytics-metrics">
        {data.metrics.map((metric, idx) => (
          <div key={idx} className="ai-chat-widget-analytics-metric">
            <span className="ai-chat-widget-analytics-metric-value">
              {metric.value}
            </span>
            <span className="ai-chat-widget-analytics-metric-label">
              {metric.label}
            </span>
            {metric.trendDirection && (
              <span
                className={`ai-chat-widget-analytics-trend ai-chat-widget-analytics-trend-${metric.trendDirection}`}>
                {metric.trendDirection === 'up' ? '\u2191' : '\u2193'}
                {metric.trend && ` ${metric.trend}`}
              </span>
            )}
          </div>
        ))}
      </div>
      {data.chart && (
        <div className="ai-chat-widget-analytics-chart">
          {data.chart.values.map((value, idx) => (
            <div key={idx} className="ai-chat-widget-analytics-chart-col">
              <div
                className="ai-chat-widget-analytics-chart-bar"
                style={{ height: `${(value / maxValue) * 100}%` }}
              />
              <span className="ai-chat-widget-analytics-chart-label">
                {data.chart!.labels[idx]}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AnalyticsStatWidget;
